__turbopack_context__.v({
  "addText": "modal-content-module__yFS6Pq__addText",
  "button": "modal-content-module__yFS6Pq__button",
  "counter": "modal-content-module__yFS6Pq__counter",
  "description": "modal-content-module__yFS6Pq__description",
  "extraWrapper": "modal-content-module__yFS6Pq__extraWrapper",
  "footer": "modal-content-module__yFS6Pq__footer",
  "image": "modal-content-module__yFS6Pq__image",
  "isMobile": "modal-content-module__yFS6Pq__isMobile",
  "modal": "modal-content-module__yFS6Pq__modal",
  "name": "modal-content-module__yFS6Pq__name",
  "price": "modal-content-module__yFS6Pq__price",
  "right": "modal-content-module__yFS6Pq__right",
  "title": "modal-content-module__yFS6Pq__title",
  "toppingWrapper": "modal-content-module__yFS6Pq__toppingWrapper",
  "weight": "modal-content-module__yFS6Pq__weight",
  "wrapper": "modal-content-module__yFS6Pq__wrapper",
});
